const Title = (function () {
  let timestamps;

  /**
   * Gets title timestamps from JSON file
   * @returns {unknown[]}
   */
  async function getTimestamps () {
    if (!timestamps) {
      // eslint-disable-next-line no-undef
      const response = await fetch('./img/title/timestamps.json', { cache: 'no-cache' });

      timestamps = await response.json();
    }

    return timestamps;
  }

  return {
    getTimestamps,
  };
})();

export default Title;
